// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"953894e4","115":"d03522cb","408":"8eedd50c","427":"d03522cb","469":"d03522cb"}[chunkId] + ".chunk.css";
};